import Tooltip from "@/components/Tooltip";
import { Button } from "@/components/ui/button";
import { PanelLeft } from "lucide-react";
import useGlobalStore from "@/stores/useGlobalStore";

export default function OpenSidebarBtn({ navVisible, tooltipContent }) {
  const { setNavVisible } = useGlobalStore();
  return (
    navVisible && (
      <Tooltip tooltipContent={tooltipContent}>
        <Button
          size="icon"
          variant="outline"
          className="bg-transparent rounded-xl border border-border-light p-2 hover:bg-gray-100 delayed-button border-none"
          onClick={() => {
            setNavVisible((prev) => {
              localStorage.setItem("navVisible", JSON.stringify(!prev));
              return !prev;
            });
          }}
        >
          <PanelLeft style={{ width: "24px", height: "24px" }} />
        </Button>
      </Tooltip>
    )
  );
}
